<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb41></breadcrumb41>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <div class="ml-md-4">
                    <b-card no-body>
                      <b-tabs active-nav-item-class="font-weight-bold text-white bg-success">
                        <b-tab title="Treatment Plan List" active>
                          <b-card-text>
                            <!-- Basic Information -->
                            <div class="card" style="border: none;">
                              <div class="card-body doctor-profile">
                                <h4>Before building a treatment plan, defining its key components is crucial. This ensures
                                  a comprehensive and tailored approach to patient care.</h4>
                                <p>Here are the essential components to consider:</p>
                                <div class="mt-3" style="font-size: 15px;">
                                  <p style="font-weight: bold;color: black;">Prescription :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> Determine if any
                                      medications are necessary to address the patient's condition.
                                    </span>
                                  </p>
                                  <p style="font-weight: bold;color: black;">Surgery :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> Indicate whether surgery is
                                      required as part of the treatment plan.</span></p>
                                  <p style="font-weight: bold;color: black;">Investigation :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> Specify any additional
                                      diagnostic tests needed for accurate diagnosis or monitoring.</span></p>
                                  <p style="font-weight: bold;color: black;">General Advice :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> Outline recommendations for
                                      lifestyle changes, diet, rehabilitation,
                                      or other supportive measures.</span></p>
                                  <p style="font-weight: bold;color: black;">Patient Trust :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> A detailed profile builds
                                      trust and helps patients choose confidently.</span></p>
                                  <p style="font-weight: bold;color: black;">Exercise :<span
                                      style=" font-weight: normal;color: rgb(114, 113, 113);"> Determine if specific
                                      exercise regimens would benefit the patient's recovery.</span></p>
                                </div>
                                <div class="row">
                                  <div class="col-md-12" id="patient_container">
                                    <div class="submit-section text-left">
                                      <router-link to="/doctor/my-treatment-plan">
                                        <button class="btn btn-primary btn-sm">
                                          Add Treatment Plan
                                        </button>
                                      </router-link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                              <div class="col-12 col-md-6 mt-2">
                                <div class="input-group form-group">
                                  <input type="text" v-model="searchQuery" class="form-control" placeholder="Search by Title of Plan" style="width:100%;"/>
                                </div>
                              </div>
                            </div>
                              <div class="">
                                <div class="table-responsive">
                                  <table>
                                    <thead>
                                      <tr>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Title of Plan
                                        </th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Status</th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Prescription
                                        </th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Surgery</th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Investigation
                                        </th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">General
                                          Advice</th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Exercise</th>
                                        <th scope="col" class="text-left"
                                          style="background-color: #F8F8F8; font-size: 13px;">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody style="font-size: 13px;">
                                      <tr v-for="(item, index) in filteredTreatmentPlans" :key="index" v-bind:key="index"
                                        v-show="setPaginate(index)">
                                        <td>
                                          {{ item.treatment_plan_name.template_name }}
                                        </td>
                                        <td>{{ item.status.template_name }}</td>
                                        <td>
                                          <!-- Button with dynamic class binding -->
                                          <button
                                            :class="item.medical_prescription.details.template_name ? 'btn-green' : 'btn-grey'"
                                            disabled>
                                            {{ item.medical_prescription.details.template_name ? 'Present' : 'Absent' }}
                                          </button><br />

                                          <span class="d-inline-block" tabindex="0">
                                            <h5 class="addcursor" data-html="true" :id="`tooltip-target-1` + index">
                                              <!-- Prescription -->
                                            </h5>
                                          </span>

                                          <b-tooltip data-html="true" v-if="item.medical_prescription.details.description"
                                            :target="`tooltip-target-1` + index" triggers="hover" placement="bottom">
                                            <div v-html="item.medical_prescription.details.description"></div>
                                          </b-tooltip>
                                        </td>
                                        <td>
                                          <!-- Button with dynamic class binding based on the presence of a value -->
                                          <button
                                            :class="item.surgery_advice.details.template_name ? 'btn-green m-1' : 'btn-grey'"
                                            disabled>
                                            {{ item.surgery_advice.details.template_name ? 'Present' : 'Absent' }}
                                          </button><br />

                                          <span class="d-inline-block" tabindex="0">
                                            <h5 class="addcursor" data-html="true" :id="`tooltip-target-2` + index">
                                              <!-- Surgery -->
                                            </h5>
                                          </span>

                                          <b-tooltip data-html="true" v-if="item.surgery_advice.details.description"
                                            :target="`tooltip-target-2` + index" triggers="hover" placement="bottom">
                                            <div v-html="item.surgery_advice.details.description"></div>
                                          </b-tooltip>
                                        </td>

                                        <td>
                                          <!-- Button with dynamic class binding based on the presence of a value -->
                                          <button
                                            :class="item.investigation_advice.details.template_name ? 'btn-green' : 'btn-grey'"
                                            disabled>
                                            {{ item.investigation_advice.details.template_name ? 'Present' : 'Absent' }}
                                          </button><br />

                                          <span class="d-inline-block" tabindex="0">
                                            <h5 class="addcursor" data-html="true" :id="`tooltip-target-3` + index">
                                              <!-- Investigation -->
                                            </h5>
                                          </span>

                                          <b-tooltip data-html="true" v-if="item.investigation_advice.details.description"
                                            :target="`tooltip-target-3` + index" triggers="hover" placement="bottom">
                                            <div v-html="item.investigation_advice.details.description"></div>
                                          </b-tooltip>
                                        </td>

                                        <td>
                                          <!-- Button with dynamic class binding based on the presence of a value -->
                                          <button
                                            :class="item.general_advice.details.template_name ? 'btn-green' : 'btn-grey'"
                                            disabled>
                                            {{ item.general_advice.details.template_name ? 'Present' : 'Absent' }}
                                          </button><br />

                                          <span class="d-inline-block" tabindex="0">
                                            <h5 class="addcursor" data-html="true" :id="`tooltip-target-4` + index">
                                              <!-- General Advice -->
                                            </h5>
                                          </span>

                                          <b-tooltip data-html="true" v-if="item.general_advice.details.description"
                                            :target="`tooltip-target-4` + index" triggers="hover" placement="bottom">
                                            <div v-html="item.general_advice.details.description"></div>
                                          </b-tooltip>
                                        </td>

                                        <td>
                                          <!-- Button with dynamic class binding based on the presence of a value -->
                                          <button :class="item.exercise.details.template_name ? 'btn-green' : 'btn-grey'"
                                            disabled>
                                            {{ item.exercise.details.template_name ? 'Present' : 'Absent' }}
                                          </button><br />

                                          <span class="d-inline-block" tabindex="0">
                                            <h5 class="addcursor" data-html="true" :id="`tooltip-target-5` + index">
                                              <!-- Exercise -->
                                            </h5>
                                          </span>

                                          <b-tooltip data-html="true" v-if="item.exercise.details.description"
                                            :target="`tooltip-target-5` + index" triggers="hover" placement="bottom">
                                            <div v-html="item.exercise.details.description"></div>
                                          </b-tooltip>
                                        </td>

                                        <td>
                                          <a class="btn btn-sm bg-warning-light" style="font-size:13px;">
                                            <router-link :to="{
                                              name: 'update-treatment-plan',
                                              params: { userId: item.name.template_name }
                                            }">
                                              <i class="far fa-edit"></i>
                                              Edit
                                            </router-link>
                                          </a>

                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <h5 v-if="treatment_plan_details.length === 0 && !showspinner
                                  " class="No_data">
                                  No Treatment Plan Found
                                </h5>
                                <!-- pagination start -->
                                <div id="pagination" v-if="treatment_plan_details.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateInvestigationCount(current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateInvestigationCount(current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                            <!-- /Basic Information -->
                          </b-card-text>
                        </b-tab>
                        <b-tab title="Treatment Components">
                          <b-card-text>
                            <!-- card data -->
                            <div class="row justify-content-center" style="margin-left: -40px;">
                              <!--symptom -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; text-align: center;color: #333333;">
                                  Symptom</p>
                                <router-link to="/doctor/symptoms">
                                  <img class="dashboard-img" src="@/assets/img/doctors/Symptoms.png" alt="Avatar"
                                    style="justify-content: center;margin-left: 65px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="$bvModal.show('Import_Symptom_modal')"
                                    style="float: left; font-size: 12px; " href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>


                                  <router-link to="/doctor/symptoms"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-symptom"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>

                                  <!-- <a data-toggle="modal" class="m-1" @click="$bvModal.show('Add_Symptom_modal')"
                          style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!-- symptom -->

                              <!-- diagnosis -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; text-align: center;color: #333333;">
                                  Diagnosis</p>
                                <router-link to="/doctor/diagnosis">
                                  <img class="dashboard-img" src="@/assets/img/doctors/Diagnosis.png" alt="Avatar"
                                    style="justify-content: center;margin-left: 60px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="
                                    $bvModal.show('Import_Diagnosis_modal')
                                    " style="float: left; font-size: 12px; " href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>

                                  <router-link to="/doctor/diagnosis"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-diagnosis"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>

                                  <!-- <a data-toggle="modal" class="m-1" @click="$bvModal.show('Add_Diagnosis_modal')"
                          style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!--diagnosis -->
                              <!--investigation -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; text-align: center;color: #333333;">
                                  Investigation
                                </p>
                                <router-link to="/doctor/investigation">
                                  <img class="dashboard-img" src="@/assets/img/doctors/Investigation.png" alt="Avatar"
                                    style="justify-content: center;margin-left: 50px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="
                                    $bvModal.show('Import_Investigation_modal')
                                    " style="float: left; font-size: 12px; " href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>

                                  <router-link to="/doctor/investigation"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-investigation"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>

                                  <!-- <a data-toggle="modal" class="m-1" @click="
                          $bvModal.show('Add_Investigation_modal');
                        open_treament('Investigation');
                        " style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!-- investigation -->
                              <!-- prescription -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; text-align: center;color: #333333;">
                                  Prescription
                                </p>
                                <router-link to="/doctor/prescription">
                                  <img class="dashboard-img" src="@/assets/img/doctors/Prescription.jpg" alt="Avatar"
                                    style="justify-content: center;margin-left: 50px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="
                                    $bvModal.show('Import_Prescription_modal')
                                    " style="float: left; font-size: 12px;" href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>

                                  <router-link to="/doctor/prescription"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-prescription"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>

                                  <!-- <a data-toggle="modal" class="m-1" @click="
                          $bvModal.show('Add_Investigation_modal');
                        open_treament('Prescription');
                        " style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!-- prescription -->
                              <!--surgery -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color:#DCDCDC; text-align: center;color: #333333;">
                                  Surgery</p>
                                <router-link to="/doctor/surgery">
                                  <img class="dashboard-img" src="@/assets/img/doctors/Surgery_Icon.jpg" alt="Avatar"
                                    style="justify-content: center;margin-left: 55px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="$bvModal.show('Import_Surgeon_modal')"
                                    style="float: left; font-size: 12px; " href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>

                                  <router-link to="/doctor/surgery"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-surgery"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>
                                  <!-- 
                        <a data-toggle="modal" class="m-1" @click="
                          $bvModal.show('Add_Investigation_modal');
                        open_treament('Surgery');
                        " style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!-- surgery -->

                              <!-- genral device -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; text-align: center;color: #333333;">
                                  General Advice
                                </p>
                                <router-link to="/doctor/general-advice">
                                  <img class="dashboard-img" src="@/assets/img/doctors/General Advice.png" alt="Avatar"
                                    style="justify-content: center;margin-left: 50px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <a data-toggle="modal" class="m-1" @click="
                                    $bvModal.show('Import_GeneralAdvice_modal')
                                    " style="float: left; font-size: 12px; " href="">
                                    <i class="fa fa-arrow-up"></i> Import</a>

                                  <router-link to="/doctor/general-advice"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <i class="fa fa-list"></i> List
                                  </router-link>

                                  <router-link to="/doctor/add-general-advice"
                                    style="float:center; margin-left: 20px; font-size: 13px;" href="">
                                    <a class="m-1" style="float: right; margin-left: 30px; font-size: 12px;" href="">
                                      <i class="fa fa-plus"></i> Add</a>
                                  </router-link>

                                  <!-- <a data-toggle="modal" class="m-1" @click="
                          $bvModal.show('Add_Investigation_modal');
                        open_treament('General');
                        " style="float: right; margin-left: 30px; font-size: 12px;" href="">
                          <i class="fa  fa-plus"></i> Add</a> -->
                                </div>
                              </div>
                              <!-- genreal device -->

                              <!-- exercise-plan -->
                              <div class="card  dashboard-card">
                                <p class="p-2"
                                  style="font-size: 16px;background-color: #DCDCDC; color: black; text-align: center;">
                                  Exercise Plan
                                </p>
                                <router-link to="/doctor/exercise-plan">
                                  <img class="dashboard-img" src="@/assets/img/doctors/exercise.png" alt="Avatar"
                                    style="justify-content: center;margin-left: 52px;" /></router-link>
                                <div class="container">
                                  <hr />
                                  <router-link style="float: right; font-size: 12px;" to="/doctor/my-exercise-plan"
                                    class="m-1">
                                    <i class="fa fa-plus"></i> Add</router-link>

                                  <router-link to="/doctor/exercise-plan" style="float:left; font-size: 13px;" href=""
                                    class="m-1">
                                    <i class="fa fa-list"></i> List
                                  </router-link>
                                </div>
                              </div>
                              <!-- exercise-plan -->

                              <!-- Popup modals -->
                              <div>
                                <b-modal id="Add_Prescription_modal" hide-footer>
                                  <template #modal-title> </template>
                                  <div class="d-block text-center"></div>
                                  <b-button class="mt-3" block
                                    @click="$bvModal.hide('Add_Prescription_modal')">Close</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Prescription_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>Medical Prescription Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />

                                  </div>
                                  <div style="height: 450px; overflow: auto; margin-bottom: 20px;">
                                    <table style="border-collapse: collapse; width: 100%; margin-bottom: 10px;">
                                      <thead>
                                        <tr>
                                          <th
                                            style="text-align: left; position: sticky; top: 0; background-color: white;">
                                            <input type="checkbox"
                                              @click="final_Medical_Prescription_function(all_Medical_Prescription); togglePrescriptionCheckAll()"
                                              v-model="checkAll" />
                                          </th>
                                          <th
                                            style="text-align: left; position: sticky; top: 0; background-color: white;">
                                            Name</th>
                                          <th
                                            style="text-align: left; position: sticky; top: 0; background-color: white;">
                                            Details</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="item in filteredMedicalPrescriptions">
                                          <td style="text-align: left;">
                                            <input type="checkbox" @click="final_Medical_Prescription_function(item)"
                                              v-model="item.selected" />
                                          </td>
                                          <td style="text-align: left;">{{ item.template_name }}</td>
                                          <td style="text-align: left;">{{ item.description }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px;" block @click="
                                    $bvModal.hide('Import_Prescription_modal');
                                  save_Medical_Prescription();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_Investigation_modal" hide-footer>
                                  <!-- <template #modal-title> -->
                                  <template #modal-title>
                                    <h3 class="modal-title w-100 mb-2">
                                      {{ add_templates.category }}
                                    </h3>
                                  </template>
                                  <div class="d-block text-center">
                                    <div class="card">
                                      <div class="card-body">
                                        <div class="row form-row">
                                          <div class="col-12 col-md-12">
                                            <div class="form-group" style="text-align: left;margin-top:-10px;">
                                              <label>{{ add_templates.category }} Template</label>

                                              <input v-model="add_templates.template_name
                                                " type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                            </div>
                                          </div>
                                          <div class="hidden-code" style="display:none;">
                                            <div class="col-12 col-md-12">
                                              <div class="form-group" style="text-align: left;">
                                                <label>Category</label>
                                                <v-select class="mr-2" required="" disabled
                                                  v-model="add_templates.category" placeholder="Select Category"
                                                  :options="all_category">
                                                </v-select>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-12" style="margin-top:-10px;">
                                            <div class="form-group testimonial" style="text-align: left;">
                                              <label>Description</label>
                                              <ckeditor :editor="editor" v-model="add_templates.description
                                                "></ckeditor>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="submit-section" style="text-align: left">
                                          <button @click="
                                            add_new_templates();
                                          $bvModal.hide(
                                            'Add_Investigation_modal'
                                          );
                                          " :disabled="disabled_template_button" class="btn btn-primary submit-btn"
                                            data-dismiss="Add_Investigation_modal" aria-label="Close">
                                            Add Template
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Investigation_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>Investigation Advice Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />
                                  </div>
                                  <div style="height: 450px; overflow: auto; margin-bottom: 20px;">
                                    <table style="border-collapse: collapse; width: 100%;">
                                      <tr>
                                        <th style="text-align: left;">
                                          <input type="checkbox"
                                            @click="final_Investigation_Advice_function(all_Investigation_Advice); toggleInvestigationCheckAll()"
                                            v-model="checkAll" />
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Name
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Details</th>
                                      </tr>
                                      <tr v-for="item in filteredInvestigationAdvice">
                                        <td>
                                          <input type="checkbox" @click="final_Investigation_Advice_function(item)"
                                            v-model="item.selected" />
                                        </td>
                                        <td style="text-align: left;">{{ item.template_name }}</td>
                                        <td style="text-align: left;">{{ item.description }}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px;" block @click="
                                    $bvModal.hide('Import_Investigation_modal');
                                  save_investigation_advice();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="add_TreatmentPlan_modal" hide-footer>
                                  <div class="modal-body doctor-profile">
                                    <div class="row">
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Treatment Plan Name</label>
                                          <input type="text" class="form-control" v-model="new_treatment.treatment_plan_name
                                            " placeholder="Treatment Plan Name" />
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Status</label>
                                          <v-select class="mr-2" placeholder="Status" v-model="new_treatment.status"
                                            :options="treatment_status">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Medical Prescription</label>
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            placeholder="Select Investigation Template" v-model="new_treatment.medical_prescription
                                              " :reduce="(option) => option.name" :options="all_prescription_template">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Surgery Advice</label>
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            placeholder="Select Investigation Template"
                                            v-model="new_treatment.surgery_advice" :reduce="(option) => option.name"
                                            :options="all_surgery_template">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Exercise Advice</label>
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            v-model="new_treatment.exercise" placeholder="Select Investigation Template"
                                            :reduce="(option) => option.name" :options="all_exercise_advice_template_name
                                              ">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Investigation Advice</label>
                                          <v-select class="mr-2" name="name" required="" label="template_name" v-model="new_treatment.investigation_advice
                                            " placeholder="Select Investigation Template"
                                            :reduce="(option) => option.name" :options="all_investigation_template">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>General Advice</label>
                                          <v-select class="mr-2" name="name" required="" label="template_name"
                                            v-model="new_treatment.general_advice"
                                            placeholder="Select Investigation Template" :reduce="(option) => option.name"
                                            :options="all_general_advice_template">
                                          </v-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6" style="margin-top: -20px;">
                                        <div class="form-group">
                                          <label>Description</label>
                                          <textarea rows="4" type="text" class="form-control"
                                            v-model="new_treatment.description" placeholder="Description" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- </form> -->

                                  <button @click="
                                    $bvModal.hide('Add_Diagnosis_modal');
                                  add_new_treatment();
                                  " :disabled="disabled_template_button" class="btn btn-primary btn-sm"
                                    data-dismiss="modal" aria-label="Close">
                                    Add Treatment
                                  </button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_TreatmentPlan_modal" hide-footer>
                                  <template #modal-title> </template>
                                  <div class="d-block text-center">
                                    <hr />

                                    <div v-for="item in all_treatment_plans">
                                      <table>
                                        <tr>
                                          <th style="text-align: left;">
                                            <input type="checkbox" @click="
                                              final_treatment_plans(
                                                all_treatment_plans
                                              )
                                              " />
                                          </th>
                                          <th style="text-align: left;">Name</th>
                                          <th style="text-align: left;">Details</th>
                                        </tr>
                                        <tr v-for="item in all_treatment_plans">
                                          <td>
                                            <input type="checkbox" @click="final_treatment_plans(item)" />
                                          </td>
                                          <td
                                            style="text-align: left; position: sticky; top: 0; background-color: white;">
                                            {{
                                              item.treatment_plan_name }}</td>
                                          <td
                                            style="text-align: left; position: sticky; top: 0; background-color: white;">
                                            {{
                                              item.description }}</td>
                                        </tr>
                                      </table>

                                      <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px;" block @click="
                                        $bvModal.hide(
                                          'Import_TreatmentPlan_modal'
                                        );
                                      save_treatment_plans();
                                      ">Import</b-button>
                                    </div>

                                    <hr />
                                  </div>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Excercise_modal" hide-footer>
                                  <template #modal-title> </template>
                                  <div class="d-block text-center"></div>
                                  <b-button class="mt-3" block
                                    @click="$bvModal.hide('Import_Excercise_modal')">Close</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_Diagnosis_modal" hide-footer>
                                  <template #modal-title>
                                    <h3>Diagnosis</h3>
                                  </template>
                                  <div class="d-block">
                                    <div class="form-group">
                                      <label>Name of Diagnosis</label>
                                      <input v-model="new_diagnosis" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                    </div>
                                    <button data-dismiss="modal" aria-label="Close" class="btn btn-primary submit-btn"
                                      @click="
                                        $bvModal.hide('Add_Diagnosis_modal');
                                      add_diagnosis();
                                      ">
                                      Save
                                    </button>
                                  </div>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Diagnosis_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>Diagnosis Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />
                                  </div>
                                  <div style="height: 450px; overflow: auto;margin-bottom:20px">
                                    <table style="text-align: left;">
                                      <tr>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          <input type="checkbox"
                                            @click="final_diagnosis_fuction(all_diagnosis); toggleDiagnosisCheckAll()"
                                            v-model="checkAll" />
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Name
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Details</th>
                                      </tr>
                                      <tr v-for="item in filteredDiagnosis">
                                        <td>
                                          <input type="checkbox" @click="final_diagnosis_fuction(item)"
                                            v-model="item.selected" />
                                        </td>
                                        <td>{{ item.diagnosis }}</td>
                                        <td>{{ item.description }}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px; " block @click="
                                    $bvModal.hide('Import_Diagnosis_modal');
                                  save_diagnosis();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_Surgeon_modal" hide-footer>
                                  <template #modal-title>
                                  </template>
                                  <div class="d-block text-center">
                                    <h3></h3>
                                  </div>
                                  <b-button class="mt-3" block
                                    @click="$bvModal.hide('Add_Surgeon_modal')">Close</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Surgeon_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>Surgery Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />
                                  </div>
                                  <div style="height: 450px; overflow: auto;margin-bottom:20px">
                                    <table style="text-align: left;">
                                      <tr>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          <input type="checkbox" @click="
                                            final_surgey_Advice_fuction(all_surgey_Advice); toggleSurgeryCheckAll()"
                                            v-model="checkAll" />
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Name
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Details</th>
                                      </tr>
                                      <tr v-for="item in filteredSurgeryAdvice">
                                        <td>
                                          <input type="checkbox" @click="final_surgey_Advice_fuction(item)"
                                            v-model="item.selected" />
                                        </td>
                                        <td>{{ item.template_name }}</td>
                                        <td>{{ item.description }}</td>
                                      </tr>
                                    </table>
                                  </div>

                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px; " block @click=" 
                                    $bvModal.hide('Import_Surgeon_modal');
                                  save_surgey_Advice();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_Symptom_modal" hide-footer>
                                  <template #modal-title>
                                    <h3>Symptom</h3>
                                  </template>
                                  <div class="d-block">
                                    <div class="form-group">
                                      <label>Symptom Name</label>
                                      <input v-model="new_complaint" type="text" class="form-control" value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                    </div>
                                    <!-- <p> {{all_sympmtoms}}</p> -->
                                    <button data-dismiss="modal" aria-label="Close" class="btn btn-primary submit-btn"
                                      @click="
                                        add_symptoms();
                                      $bvModal.hide('Add_Symptom_modal');
                                      ">
                                      Save
                                    </button>
                                  </div>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Symptom_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>Symptoms Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />
                                  </div>
                                  <div style="height: 450px; overflow: auto; margin-bottom: 20px;">
                                    <table style="text-align: left;">
                                      <tr>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          <input type="checkbox"
                                            @click="final_symptoms(all_sympmtoms); toggleSymptomCheckAll()"
                                            v-model="checkAll" />
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Name
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Details</th>
                                      </tr>
                                      <tr v-for="item in filteredSymptoms">
                                        <td>
                                          <input type="checkbox" @click="final_symptoms(item)" v-model="item.selected" />
                                        </td>
                                        <!-- v-model="final_symptoms[item]" -->
                                        <td>{{ item.complaint }}</td>
                                        <td>{{ item.description }}</td>
                                      </tr>
                                    </table>
                                  </div>

                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px;" block @click="
                                    $bvModal.hide('Import_Symptom_modal');
                                  save_syptoms();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_GeneralAdvice_modal" hide-footer>
                                  <template #modal-title>
                                    Add_GeneralAdvice_modal
                                  </template>
                                  <div class="d-block text-center">
                                    <h3>Add_GeneralAdvice_modal !</h3>
                                  </div>
                                  <b-button class="btn btn-primary btn-sm mb-1" block @click="
                                    $bvModal.hide('Add_GeneralAdvice_modal')
                                    ">Close</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_GeneralAdvice_modal" hide-footer>
                                  <template #modal-title>
                                    <h2>General Advice Import</h2>
                                  </template>
                                  <div>
                                    <input type="text" v-model="searchQuery" placeholder="Search by Name"
                                      style="margin-bottom: 20px;" class="search_field" />
                                  </div>
                                  <div style="height: 450px; overflow: auto; margin-bottom: 20px;">
                                    <table style="text-align: left;">
                                      <tr>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          <input type="checkbox"
                                            @click="final_general_advice_function(all_General_Advice); toggleGeneralCheckAll()"
                                            v-model="checkAll" />
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Name
                                        </th>
                                        <th style="text-align: left; position: sticky; top: 0; background-color: white;">
                                          Details</th>
                                      </tr>
                                      <tr v-for="item in filteredGeneralAdvice">
                                        <td>
                                          <input type="checkbox" @click="final_general_advice_function(item)"
                                            v-model="item.selected" />
                                        </td>
                                        <td>{{ item.template_name }}</td>
                                        <td>{{ item.description }}</td>
                                      </tr>
                                    </table>
                                  </div>
                                  <b-button class="btn btn-primary btn-sm mb-1" style="width: 150px;" block @click="
                                    $bvModal.hide('Import_GeneralAdvice_modal');
                                  save_general_advice();
                                  ">Import</b-button>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Add_Hospital_modal" hide-footer>
                                  <template #modal-title>
                                    <h3 class="modal-title w-100">
                                      Hospital
                                    </h3>
                                  </template>
                                  <div class="d-block text-center">
                                    <div class="modal-content-lg">

                                      <!-- Nav tabs -->
                                      <ul class="nav nav-tabs">
                                        <li class="nav-item">
                                          <a class="nav-link active" data-toggle="tab" href="#hospital-name"
                                            style="color: #3a6c51;">Hospital Name</a>
                                        </li>
                                        <li class="nav-item">
                                          <a class="nav-link" data-toggle="tab" href="#hospital-gallery"
                                            style="color: #3a9eaf;">Hospital Gallery</a>
                                        </li>
                                      </ul>
                                      <!-- Tab panes -->
                                      <div class="tab-content">
                                        <!-- Hospital Name Tab -->
                                        <div id="hospital-name" class="tab-pane active">
                                          <div class="row form-row">
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Type Of Hospital</label>
                                                <v-select class="mr-2" name="sub_category_name" required=""
                                                  label="sub_category_name" placeholder="Select type of Hospital" v-model="new_hospital.type_of_hospital
                                                    " :reduce="(option) => option.sub_category_name"
                                                  :options="hospital_types">
                                                </v-select>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Name Of Hospital
                                                  <span class="text-danger">*</span></label>
                                                <input v-model="new_hospital.name_of_hospital
                                                  " placeholder="Name Of Hospital" type="text" class="form-control"
                                                  value="" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>No Of Beds</label>
                                                <input v-model="new_hospital.no_of_beds" type="text"
                                                  placeholder="No Of Beds" class="form-control" value=""
                                                  oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Website</label>
                                                <input v-model="new_hospital.website" type="text" placeholder="Website"
                                                  class="form-control" value="" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Tagline</label>
                                                <input v-model="new_hospital.hospital_tagline
                                                  " type="text" placeholder="Tagline" class="form-control" value="" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Address</label>
                                                <input v-model="new_hospital.address" type="text" placeholder="Address"
                                                  class="form-control" value="" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>State</label>
                                                <v-select class="mr-2" name="state" required="" label="state"
                                                  placeholder="Select State" v-model="new_hospital.state"
                                                  :reduce="(option) => option.state" @input="
                                                    get_cities_for_addinghospital()
                                                    " :options="states">
                                                </v-select>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>City
                                                  <span class="text-danger">*</span></label>
                                                <v-select class="mr-2" name="city" required="" label="city"
                                                  placeholder="Select City" v-model="new_hospital.city"
                                                  :reduce="(option) => option.city" :options="cities">
                                                </v-select>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Suburb</label>
                                                <input v-model="new_hospital.suburb" type="text" placeholder="Suburb"
                                                  class="form-control" value="" />
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                              <div class="form-group">
                                                <label>Pincode</label>
                                                <input v-model="new_hospital.pincode" type="text" placeholder="Pincode"
                                                  class="form-control" value=""
                                                  oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div id="hospital-gallery" class="tab-pane">
                                          <div class="card">
                                            <div class="card-body">
                                              <div class="container">
                                                <div class="row form-row">
                                                  <div class="col-12 col-md-6">
                                                    <div class="d-flex form-group">
                                                      <div class="change-avatar">
                                                        <div class="profile-img">
                                                          <img
                                                            v-bind:src="new_hospital.photo_1 ? config.base_url_for_Image + new_hospital.photo_1 : loadImg('doctor-thumb-02.jpg')"
                                                            alt="User Image" />
                                                        </div>
                                                        <div class="upload-img">
                                                          <div class="change-photo-btn" style="margin-left: 41px;">
                                                            <span><i class="fa fa-upload"></i> Upload Photo</span>
                                                            <input type="file" class="upload" accept="image/*"
                                                              @change="onFileChange($event, 'hospital_photo_1')" />
                                                          </div>
                                                          <small class="form-text text-muted">Allowed JPG, GIF, or PNG.
                                                            Max
                                                            size
                                                            of 2MB</small>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-md-6">
                                                    <div class="d-flex form-group">
                                                      <div class="change-avatar">
                                                        <div class="profile-img">
                                                          <img
                                                            v-bind:src="new_hospital.photo_2 ? config.base_url_for_Image + new_hospital.photo_2 : loadImg('doctor-thumb-02.jpg')"
                                                            alt="User Image" />
                                                        </div>
                                                        <div class="upload-img">
                                                          <div class="change-photo-btn" style="margin-left: 41px;">
                                                            <span><i class="fa fa-upload"></i> Upload Photo</span>
                                                            <input type="file" class="upload" accept="image/*"
                                                              @change="onFileChange($event, 'hospital_photo_2')" />
                                                          </div>
                                                          <small class="form-text text-muted">Allowed JPG, GIF, or PNG.
                                                            Max
                                                            size
                                                            of 2MB</small>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-md-6">
                                                    <div class="d-flex form-group">
                                                      <div class="change-avatar">
                                                        <div class="profile-img">
                                                          <img
                                                            v-bind:src="new_hospital.photo_3 ? config.base_url_for_Image + new_hospital.photo_3 : loadImg('doctor-thumb-02.jpg')"
                                                            alt="User Image" />
                                                        </div>
                                                        <div class="upload-img">
                                                          <div class="change-photo-btn" style="margin-left: 41px;">
                                                            <span><i class="fa fa-upload"></i> Upload Photo</span>
                                                            <input type="file" class="upload" accept="image/*"
                                                              @change="onFileChange($event, 'hospital_photo_3')" />
                                                          </div>
                                                          <small class="form-text text-muted">Allowed JPG, GIF, or PNG.
                                                            Max
                                                            size
                                                            of 2MB</small>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col-12 col-md-6">
                                                    <div class="d-flex form-group">
                                                      <div class="change-avatar">
                                                        <div class="profile-img">
                                                          <img
                                                            v-bind:src="new_hospital.photo_4 ? config.base_url_for_Image + new_hospital.photo_4 : loadImg('doctor-thumb-02.jpg')"
                                                            alt="User Image" />
                                                        </div>
                                                        <div class="upload-img">
                                                          <div class="change-photo-btn" style="margin-left: 41px;">
                                                            <span><i class="fa fa-upload"></i> Upload Photo</span>
                                                            <input type="file" class="upload" accept="image/*"
                                                              @change="onFileChange($event, 'hospital_photo_4')" />
                                                          </div>
                                                          <small class="form-text text-muted">Allowed JPG, GIF, or PNG.
                                                            Max
                                                            size
                                                            of 2MB</small>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="submit-section" style="text-align:left">
                                          <button @click="
                                            add_hospital();
                                          $bvModal.hide('Add_Hospital_modal');
                                          " :disabled="disabled" class="btn btn-primary submit-btn mb-2 mt-2"
                                            data-dismiss="modal" aria-label="Close">
                                            Add Hospital
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-modal>
                              </div>
                              <div>
                                <b-modal id="Import_Hospital_modal" hide-footer>
                                  <template #modal-title> </template>
                                  <div class="d-block text-center"></div>
                                  <b-button class="btn btn-primary btn-sm mb-1" block
                                    @click="$bvModal.hide('Import_Hospital_modal')">Close</b-button>
                                </b-modal>
                              </div>
                              <!-- end Popup modals -->
                            </div>
                            <!-- /card data -->
                          </b-card-text>
                        </b-tab>
                      </b-tabs>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import config from "../../../services/CommonApi";
export default {

  components: {
    ckeditor: CKEditor.component,
    // VueCsvImport,
  },
  data() {
    return {
      searchQuery: '',
      checkAll: false,
      showspinner: false,
      treatment_plan_details: [],

      current: 1,
      paginate: 10,
      paginate_total: 0,

      searchQuery: '',
      all_Medical_Prescription: [/* Your data goes here */],
      all_Investigation_Advice: [/* Your data goes here */],
      all_diagnosis: [/* Your data goes here */],
      all_sympmtoms: [/* Your data goes here */],
      all_surgey_Advice: [/* Your data goes here */],
      csv: null,
      cities: [],
      disabled: true,
      editor: ClassicEditor,
      showspinner: false,
      disabled_template_button: true,
      new_complaint: "",
      new_diagnosis: "",
      treatment_plan_details: [],
      all_surgery_template: [],
      all_exercise_advice_template: [],
      all_general_advice_template: [],
      all_investigation_template: [],
      all_exercise_advice_template_name: [],
      all_General_Advice: [/* Your data goes here */],
      //Diagnosis

      final_diagnosis: [],
      all_Medical_Prescription: [],
      final_Medical_Prescription: [],
      all_General_Advice: [],
      final_General_Advice: [],

      all_surgey_Advice: [],
      final_surgery_Advice: [],

      all_Investigation_Advice: [],
      final_Investigation_Advice: [],

      all_category: [],
      states: [],
      hospital_types: [],
      all_sympmtoms: [],
      all_treatment_plans: [],
      final_symptom: [],
      final_treatment_plan: [],
      all_prescription_template: [],
      treatment_status: ["Active", "Inactive"],

      new_hospital: {
        type_of_hospital: "",
        name_of_hospital: "",
        no_of_beds: "",
        website: "",
        hospital_tagline: "",
        address: "",
        state: "",
        city: "",
        suburb: "",
        pincode: "",
        photo_1: "",
        photo_2: "",
        photo_3: "",
        photo_4: "",
      },
      config: config,

      new_treatment: {
        treatment_plan_name: "",
        status: "Active",
        medical_prescription: "",
        surgery_advice: "",
        doctor: this.user_id,
        exercise: "",
        investigation_advice: "",
        general_advice: "",
        description: "",
      },

      add_templates: {
        category: "",
        template_name: "",
        description: "",
        doctor: this.user_id,
      }
    };
  },

  watch: {
    template_validation() {
      if (
        this.add_templates.category === "" ||
        this.add_templates.category === null ||
        this.add_templates.template_name === ""
      ) {
        this.disabled_template_button = true;
      } else {
        this.disabled_template_button = false;
      }
    },
    new_treatment_validation() {
      if (
        this.new_treatment.treatment_plan_name === "" ||
        this.new_treatment.status === "" ||
        this.new_treatment.status === null
      ) {
        this.disabled_template_button = true;
      } else {
        this.disabled_template_button = false;
      }
    },

    new_hospital: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },

  computed: {

    filteredTreatmentPlans() {
      const searchQuery = this.searchQuery.toLowerCase().trim();
      return this.treatment_plan_details.filter(item => {
        const treatmentPlanName = item.treatment_plan_name.template_name.toLowerCase();
        return treatmentPlanName.includes(searchQuery);
      });
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),

    template_validation() {
      return (
        this.add_templates.category &&
        this.add_templates.template_name &&
        this.add_templates.description
      );
    },

    filteredMedicalPrescriptions() {
      return this.all_Medical_Prescription.filter(item => {
        return item.template_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },

    filteredInvestigationAdvice() {
      return this.all_Investigation_Advice.filter(item => {
        return item.template_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },

    filteredDiagnosis() {
      return this.all_diagnosis.filter(item => {
        return item.diagnosis.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },

    filteredSymptoms() {
      return this.all_sympmtoms.filter(item => {
        return item.complaint.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },
    filteredGeneralAdvice() {
      return this.all_General_Advice.filter(item => {
        return item.template_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },
    filteredSurgeryAdvice() {
      return this.all_surgey_Advice.filter(item => {
        return item.template_name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    },
    new_treatment_validation() {
      return (
        this.new_treatment.treatment_plan_name && this.new_treatment.status
      );
    },
  },


  methods: {

    // checked all checkboxes
    toggleInvestigationCheckAll() {
      this.filteredInvestigationAdvice.forEach(item => {
        item.selected = !this.checkAll;
      });
    },
    togglePrescriptionCheckAll() {
      this.filteredMedicalPrescriptions.forEach(item => {
        item.selected = !this.checkAll;
      });
    },

    toggleDiagnosisCheckAll() {
      this.filteredDiagnosis.forEach(item => {
        item.selected = !this.checkAll;
      });
    },

    toggleSurgeryCheckAll() {
      this.filteredSurgeryAdvice.forEach(item => {
        item.selected = !this.checkAll;
      });
    },

    toggleSymptomCheckAll() {
      this.filteredSymptoms.forEach(item => {
        item.selected = !this.checkAll;
      });
    },

    toggleGeneralCheckAll() {
      this.filteredGeneralAdvice.forEach(item => {
        item.selected = !this.checkAll;
      });
    },


    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end

    /* Get All Treatment Plan Details */
    async get_plan_details() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data("sahaj.template.get_plan_details", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.treatment_plan_name) {
            this.treatment_plan_details = res.treatment_plan_name;
            this.paginate_total = Math.ceil(
              this.treatment_plan_details.length / this.paginate
            );
          }
          this.filteredTreatmentPlans = this.filterTreatmentPlans();
        }
      );
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    onFileChange(e, photo) {
      var files = e.target.files;
      if (!files.length) return;
      this.createImage(files[0], photo);
    },

    createImage(file, photo) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (photo === "main_image") {
          this.update_doctor_profile(file.name, e.target.result);
        } else if (photo === "doctor_photo_1") {
          this.doctor_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_2") {
          this.doctor_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_3") {
          this.doctor_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_4") {
          this.doctor_gallery_photo_4_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_1") {
          this.hospital_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_2") {
          this.hospital_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_3") {
          this.hospital_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_4") {
          this.hospital_gallery_photo_4_upload(file.name, e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },

    /* Upload HospitaL Gallary Image 1 API */
    async hospital_gallery_photo_1_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_1_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_1 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 2 API */
    async hospital_gallery_photo_2_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_2_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_2 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 3 API */
    async hospital_gallery_photo_3_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_3_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_3 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 4 API */
    async hospital_gallery_photo_4_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_4_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_4 = res.data.file_url;
        }
      });
    },

    /* Get Healthcare Sub Categories */
    async get_healthcare_sub_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.hospital_types = res.data;
        }
      });
    },

    /* Get Healthcare Categories */
    async get_healthcare_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.healthcare_practitioner_categories = res.data;
        }
      });
    },

    async get_cities_for_addinghospital() {
      this.new_hospital.city = "";
      const params = new URLSearchParams();
      params.append("state", this.new_hospital.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    /* Get All Cities */
    async get_allcities() {
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.all_cities = res.message;
      });
    },

    /* Get Cities */
    async get_cities() {
      // this.doctor_profile.city = "";
      const params = new URLSearchParams();
      params.append("state", this.doctor_profile.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    async get_states() {
      await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
        this.states = res.message;
      });
    },

    add_hospital() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Hospital...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var data = new FormData();
        data.append("data", JSON.stringify(this.new_hospital));
        CommonApi.post_data("sahaj.api.add_hospital", data).then((res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            // this.get_hospital_list();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          (this.new_hospital.type_of_hospital = ""),
            (this.new_hospital.name_of_hospital = ""),
            (this.new_hospital.no_of_beds = ""),
            (this.new_hospital.website = ""),
            (this.new_hospital.state = ""),
            (this.new_hospital.city = ""),
            (this.new_hospital.suburb = ""),
            (this.new_hospital.pincode = "");
        });
      }
    },

    validateForm() {
      if (
        this.new_hospital.name_of_hospital === "" ||
        this.new_hospital.city === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    async final_treatment_plans(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_treatment_plan.push(item[i]);
        }
      } else {
        this.final_treatment_plan.push(item);
      }
    },

    async final_symptoms(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_symptom.push(item[i]);
        }
      } else {
        this.final_symptom.push(item);
      }
    },

    async final_diagnosis_fuction(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_diagnosis.push(item[i]);
        }
      } else {
        this.final_diagnosis.push(item);
      }
    },
    async final_Medical_Prescription_function(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_Medical_Prescription.push(item[i]);
        }
      } else {
        this.final_Medical_Prescription.push(item);
      }
    },
    async final_general_advice_function(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_General_Advice.push(item[i]);
        }
      } else {
        this.final_General_Advice.push(item);
      }
    },

    async final_surgey_Advice_fuction(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_surgery_Advice.push(item[i]);
        }
      } else {
        this.final_surgery_Advice.push(item);
      }
    },
    async final_Investigation_Advice_function(item) {
      if (item.length) {
        for (let i = 0; i < item.length; i++) {
          this.final_Investigation_Advice.push(item[i]);
        }
      } else {
        this.final_Investigation_Advice.push(item);
      }
    },

    async save_investigation_advice() {
      var data_post = this.final_Investigation_Advice;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_investigation_advice_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_surgey_Advice() {
      var data_post = this.final_surgery_Advice;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_surgery_advice_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            //   showConfirmButton: true,
            // });
            // this.$emit("close");
            // window.location.reload();
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_general_advice() {
      var data_post = this.final_General_Advice;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_general_advice_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_Medical_Prescription() {
      var data_post = this.final_Medical_Prescription;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_medical_prescription_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_diagnosis() {
      var data_post = this.final_diagnosis;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_diagnosis_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        console.log(res)
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_syptoms() {
      var data_post = this.final_symptom;
      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_complaints_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async save_treatment_plans() {
      var ex = [];

      var data_post = this.final_treatment_plan;

      var bodyFormData = new FormData();
      bodyFormData.append("data", JSON.stringify(data_post));
      bodyFormData.append("practitioner", this.user_id);

      await CommonApi.post_data(
        "sahaj.v1.master.import_treatment_plan_dr",
        bodyFormData
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code === 417) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Err Occured!!",
            showConfirmButton: true,
          });
        }
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.$emit("close");
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async get_symptoms() {
      let category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data("sahaj.v1.master.complaints_for_import", params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_sympmtoms = res.data;  // Corrected the spelling of 'symptoms' here
        }
      } catch (error) {
        console.error("Error fetching symptoms:", error);
        this.showspinner = false;
      }
    },


    async get_treatment_plan() {
      await CommonApi.get_data(
        "sahaj.v1.master.treatment_plan_for_import"
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_treatment_plans = res.data;
        }
      });
    },

    async add_diagnosis() {
      this.$swal({
        text: "Adding Diagnosis...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        diagnosis: this.new_diagnosis,
        practitioner: this.user_id,
      };
      await CommonApi.post_data("sahaj.api.add_diagnosis_dr", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_diagnosis();
            this.diagnosis.push({ diagnosis: this.new_diagnosis });
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.new_diagnosis = "";
        }
      );
    },
    async add_symptoms() {
      this.$swal({
        text: "Adding Symptoms...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        complaint: this.new_complaint,
        practitioner: this.user_id,
      };
      await CommonApi.post_data("sahaj.api.add_complaints_dr", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_complaints_dr();
            this.complaint.push({ complaint: this.new_complaint });
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.new_complaint = "";
        }
      );
    },

    async get_template_category() {
      await CommonApi.get_data("sahaj.template.get_template_category").then(
        (res) => {
          this.showspinner = false;
          if (res && res.message) {
            this.all_category = res.message;
          }
        }
      );
    },

    async add_new_templates() {
      this.$swal({
        text: "Adding Template...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await CommonApi.post_data(
        "sahaj.template.add_templates",
        this.add_templates
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          this.get_medical_prescription_templates_list();
          this.$emit("close");
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: res.message,
            showConfirmButton: true,
          });
        }
        this.add_templates.category = "";
        this.add_templates.template_name = "";
        this.add_templates.description = "";
      });
    },
    /* Get All Prescription Template Plan  */
    async get_medical_prescription_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_medical_prescription_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_prescription_template = res.data;
        }
      });
    },

    changed_surgery(e) {
      this.selected_surgery_template =
        this.all_surgery_template.find((data) => data.name === e)
          .description !== null
          ? this.all_surgery_template.find((data) => data.name === e)
            .description
          : "";
    },

    /* Get All Surgery Template Plan  */
    async get_surgery_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_surgery_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_surgery_template = res.data;
        }
      });
    },
    /* Get All Exercise Advice Template Plan  */
    async get_exercise_templates_list() {
      const params = new URLSearchParams();
      params.append("practitioner", this.user_id);
      await CommonApi.get_data(
        "sahaj.v1.physio.get_therapy_template_plan_dr",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_exercise_advice_template = res.data;

          for (let i = 0; i < res.data.length; i++) {
            this.all_exercise_advice_template_name.push(res.data[i].plan_name);
          }
        }
      });
    },
    changed_investigation(e) {
      this.selected_investigation_template =
        this.all_investigation_template.find((data) => data.name === e)
          .description !== null
          ? this.all_investigation_template.find((data) => data.name === e)
            .description
          : "";
    },
    async get_investigation_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_investigation_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_investigation_template = res.data;
        }
      });
    },

    /* Get All General Advice Template Plan   */
    async get_general_advice_templates_list() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_general_advice_templates_list",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_general_advice_template = res.data;
        }
      });
    },

    changed_general_advice(e) {
      this.selected_general_advice_template =
        this.all_general_advice_template.find((data) => data.name === e)
          .description !== null
          ? this.all_general_advice_template.find((data) => data.name === e)
            .description
          : "";
    },
    async add_new_treatment() {
      await CommonApi.post_data(
        "sahaj.template.add_treatment_plan",
        JSON.stringify(this.new_treatment)
      ).then((res) => {
        this.showspinner = false;
        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
          (this.new_treatment.treatment_plan_name = ""),
            (this.new_treatment.medical_prescription = ""),
            (this.new_treatment.surgery_advice = ""),
            (this.new_treatment.exercise = ""),
            (this.new_treatment.investigation_advice = "");
          this.new_treatment.general_advice = "";
          this.new_treatment.description = "";
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },

    async get_diagnosis() {
      const category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data(`sahaj.v1.master.diagnosis_for_import`, params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_diagnosis = res.data;
        }
      } catch (error) {
        console.error("Error fetching diagnosis:", error);
        this.showspinner = false;
      }
    },



    async get_Mediacal_Prescription() {
      let category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data(`sahaj.v1.master.medical_prescription_for_import`, params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_Medical_Prescription = res.data;
        }
      } catch (error) {
        console.error("Error fetching medical prescriptions:", error);
        this.showspinner = false;
      }
    },


    async get_General_Advice() {
      let category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data("sahaj.v1.master.general_advice_for_import", params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_General_Advice = res.data;
        }
      } catch (error) {
        console.error("Error fetching general advice:", error);
        this.showspinner = false;
      }
    },


    async get_surgey_Advice() {
      let category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data("sahaj.v1.master.surgery_advice_for_import", params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_surgey_Advice = res.data;
        }
      } catch (error) {
        console.error("Error fetching surgery advice:", error);
        this.showspinner = false;
      }
    },


    async get_Investigation_Advice() {
      let category = localStorage.getItem("healthcareCategory");
      const params = new URLSearchParams();
      params.append("category", category);

      try {
        const res = await CommonApi.get_data("sahaj.v1.master.investigation_advice_for_import", params);
        this.showspinner = false;
        if (res && res.data) {
          this.all_Investigation_Advice = res.data;
        }
      } catch (error) {
        console.error("Error fetching investigation advice:", error);
        this.showspinner = false;
      }
    },


    open_treament(type) {
      if (type === "Prescription") {
        this.add_templates.category = this.all_category[1];
      } else if (type === "Exercise") {
        this.add_templates.category = this.all_category[2];
      } else if (type === "General") {
        this.add_templates.category = this.all_category[3];
      } else if (type === "Surgery") {
        this.add_templates.category = this.all_category[4];
      } else if (type === "Investigation") {
        this.add_templates.category = this.all_category[5];
      }
    },

  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_plan_details();

    // this.get_plan_details();
    this.get_symptoms();
    this.get_treatment_plan();
    this.get_diagnosis();
    this.get_Mediacal_Prescription();
    this.get_General_Advice();
    this.get_surgey_Advice();
    this.get_Investigation_Advice();
    this.get_template_category();
    this.get_states();
    this.get_allcities();
    this.get_healthcare_categories();
    this.get_healthcare_sub_categories();
    this.get_medical_prescription_templates_list();
    this.get_surgery_advice_templates();
    this.get_exercise_templates_list();
    this.get_investigation_advice_templates();
    this.get_general_advice_templates_list();
  },
};
</script>
<style>
.search_field {
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #A9A9A9;
}

.btn-green,
.btn-grey {
  font-size: 13px;

  border-radius: 5px;
  padding: 5px 10px;
  width: 80px;
  transition: 0.3s;
}

.btn-green {
  background-color: #A8D5BA;
  /* Light green background for 'Present' */
  color: #333333;
  /* Light black (dark grey) text for 'Present' */
  border: 1px solid #8FCB67;
  /* Slightly darker green border */
}

.btn-green:hover {
  background-color: #8FCB67;
  /* Slightly darker green on hover */
}

.btn-grey {
  background-color: #E0E0E0;
  /* Light gray background for 'Not Present' */
  color: #B0B0B0;
  /* Muted grey text for 'Not Present' */
  border: 1px solid #BFBFBF;
}

.btn-grey:hover {
  background-color: #D0D0D0;
  /* Slightly darker gray on hover */

}</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/TreatmentPlan.vue